(() => {
  if (window.pmwBetasiOffersReady) return;
  window.pmwBetasiOffersReady = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-betasi-offer-open]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const rawRoomId = link.dataset.betasiRoomStandardId;
    const rawPackageId = link.dataset.betasiPackageId;
    const rawServiceId = link.dataset.betasiServiceItemId;
    const isId = (value) => /^[1-9]\d*$/.test(value || '') && Number.isSafeInteger(Number(value));
    if (!isId(rawRoomId) && !isId(rawPackageId) && !isId(rawServiceId)) return;
    if (typeof window.BetasiBooking?.Open !== 'function') return;

    const locale = (document.documentElement.lang || 'pl').toLowerCase().split('-')[0];
    const isService = !isId(rawRoomId) && !isId(rawPackageId) && isId(rawServiceId);
    const configuration = isService ? {
      context: 'pmw',
      module: 'service',
      salesPoint: 'Recepcja',
      itemId: rawServiceId,
      itemType: 'standard'
    } : {
      module: 'booking',
      context: 'pmw',
      target: 'frame',
      blankHeader: true,
      lang: ['pl', 'en', 'uk'].includes(locale) ? locale : 'pl'
    };
    if (isId(rawRoomId)) configuration.roomStandardId = Number(rawRoomId);
    else if (isId(rawPackageId)) configuration.packageId = Number(rawPackageId);

    try {
      window.BetasiBooking.Open(configuration);
      event.preventDefault();
    } catch (error) {
      // Keep the direct offer link usable if the widget fails.
      console.warn('Betasi offer widget unavailable; using the booking link.', error);
    }
  });
})();
